import axios from 'axios'
import store from '@/store/index.js'
import router from '@/router/index'

import { requestPrefix } from '@/utils/common'

const fetch = axios.create({});

fetch.defaults.baseURL = requestPrefix
fetch.defaults.headers.get['content-type'] = 'application/json;charset=UTF-8'
fetch.interceptors.request.use(config => { // 添加拦截器1
  const url = config.url;
  if ("/login" !== url) {
    let accessToken = store.getters.accessToken;
    if (accessToken) {
      config.headers.accessToken = accessToken
    } else {
      // 跳转到登录页面(这里使用router，是因为路由文件引入到了此文件里)
      router.push('/login')
    }
  }
  return config
},error => Promise.reject(error)
)
fetch.interceptors.response.use(config => { // 添加拦截器2
  //token失效 待定
  if (!config.data.status) {
    const code = config.data.code;
    if (code && code == 401) {
      setTimeout(function () {
        //控制路由跳转或者直接改变href到登录页
        router.push('/login')
      }, 1000)
    }
  }
  return config
}, e => {
  return Promise.reject(e)
});

export default fetch;
